/* unplugin-vue-components disabled */import { render } from "./wv-docs.vue?vue&type=template&id=78abad84&scoped=true"
import script from "./wv-docs.vue?vue&type=script&lang=js"
export * from "./wv-docs.vue?vue&type=script&lang=js"

import "./wv-docs.vue?vue&type=style&index=0&id=78abad84&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78abad84"],['__file',"src/pages/settings/admin/weaviate/wv-docs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78abad84"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78abad84', __exports__)) {
    api.reload('78abad84', __exports__)
  }
  
  module.hot.accept("./wv-docs.vue?vue&type=template&id=78abad84&scoped=true", () => {
    api.rerender('78abad84', render)
  })

}


export default __exports__